<template>
  <div>
    <div class="container fr-aic fr-jcsb">
      <comp-tab :data="[{ label: '售卖中', value: 1 }, { label: '已售罄', value: 2 }, { label: '仓库中', value: 3 }]" v-model="status" />
      <el-button @click="$router.push({ name: 'products-edit' })" size="mini" type="primary">发布商品</el-button>
    </div>
    <div class="container">
      <el-form :inline="true" class="demo-form-inline" size="mini">
        <el-form-item label="商品ID">
          <el-input placeholder="请输入商品ID" v-model="params.id"></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input placeholder="请输入商品名" v-model="params.name"></el-input>
        </el-form-item>
        <el-form-item label="商品编码">
          <el-input placeholder="请输入商品编码" v-model="params.number"></el-input>
        </el-form-item>
        <el-form-item label="请选择商品分组">
          <el-select placeholder="选择商品分组" v-model="params.categoryid">
            <el-option :key="category.id" :label="category.name.slice(1).split('/')[0]" :value="category.id" v-for="category in categories"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="params" class="demo-form-inline" size="mini">
        <el-form-item label="销量区间">
          <el-input placeholder="最低销量" v-model="params.salesvolumegreaterthan"></el-input>
        </el-form-item>
        <el-form-item>-</el-form-item>
        <el-form-item>
          <el-input placeholder="最高销量" v-model="params.salesvolumelessthan"></el-input>
        </el-form-item>
      </el-form>
      <el-button @click="onSearch" size="small">筛选</el-button>
      <el-button @click="clearFilter" style="color: #4E759E;" size="small" type="text">清空筛选条件</el-button>
    </div>

    <div class="container">
      <el-table :data="list" @selection-change="handleSelectionChange" border ref="table" style="width: 100%">
        <el-table-column align="center" header-align="center" type="selection" width="40px"></el-table-column>

        <el-table-column align="center" header-align="center" label="ID" prop="id" width="80px" />
        <el-table-column label="商品" width="300">
          <template slot-scope="scope">
            <div class="order-info">
              <div class="order-info_img">
                <comp-imger :src="scope.row.imagesList.length ? scope.row.imagesList[0] : ''" />
              </div>
              <div class="order-info_base">
                <div>
                  <span @click="onEdit(scope.row.id)" style="cursor: pointer;color:#5c92c5">{{ scope.row.name }}</span>
                  <div class="color3" style="font-size: 14px;">¥ {{ minPrice(scope.row) / 100 }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="总销量" prop="salesvolume" sortable />
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ new Date(scope.row.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row.id)" size="small" type="text">编辑</el-button>
            <el-button @click="onOffline(scope.row)" size="small" type="text" v-if="scope.row.online === 1">下架</el-button>
            <el-button @click="onOnline(scope.row)" size="small" type="text" v-if="scope.row.online === 0">上架</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="table-bottom">
        <div class="mutil-action">
          <el-button @click="onClickAllItem" size="small" type="text">全选</el-button>
          <el-button :disabled="!selectTable.length" @click="onBatchOffline" size="small" style="margin-right: 10px;" type="text">批量下架</el-button>
          <el-dropdown @command="onBatchCategory" trigger="click">
            <el-button :disabled="!selectTable.length" size="small" type="text">
              批量改分组
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>

            <el-dropdown-menu slot="dropdown">
              <div style="height: 200px; overflow: auto;">
                <el-dropdown-item :command="`${i.id}`" :key="i.id" v-for="i in categories">{{ i.name.slice(1).split('/')[0] }}</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-button v-if="hasMore" :loading="loadmore" @click="getProducts" size="small" type="primary">加载更多</el-button>
        <span style="color: #ccc; font-size: 12px;" v-else>已加载全部，没有更多了</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../../components/tab/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

export default {
  components: {
    'comp-tab': Tab
  },
  data() {
    return {
      status: 1,
      list: [],
      categories: [],
      selectTable: [],
      params: {
        id: '',
        name: '',
        number: '',
        categoryid: '',
        salesvolumegreaterthan: '',
        salesvolumelessthan: '',
        count: 20,
        idlessthan: 0,
        sortby: 1,
        sort: 1
      },
      loadmore: false,
      hasMore: true,
      token: ''
    };
  },
  watch: {
    status() {
      this.list = [];
      this.getProducts();
    }
  },
  created() {
    this.token = getToken();
    this.getProducts();

    rpc(
      'StoreCategoryService.GetCategoryList',
      M('CategoryListQueryRequest', {
        token: M('Token', { token: this.token }),
        ishidden: 2,
        level: 1,
        count: 100,
        sortby: 1
      })
    ).then(res => {
      this.categories = res.categorylistList;
    });
  },
  methods: {
    onClickAllItem() {
      this.$refs.table.toggleAllSelection();
    },

    onChangeCheckBox(row) {
      this.$refs.table.toggleRowSelection(row);
    },

    // 搜索
    clearFilter() {
      this.params = {
        id: '',
        name: '',
        number: '',
        categoryid: '',
        salesvolumegreaterthan: '',
        salesvolumelessthan: '',
        count: 100,
        idlessthan: 0,
        sortby: 1,
        sort: 1
      };
      this.list = [];
      this.getProducts();
    },

    // 搜索
    onSearch() {
      this.list = [];
      this.getProducts();
    },

    // 商品列表
    getProducts() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.isonline = 0;
      this.params.hasquantity = 0;
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      if (this.status === 1) {
        this.params.isonline = 1;
      }
      if (this.status === 2) {
        this.params.hasquantity = 2;
      }
      if (this.status === 3) {
        this.params.isonline = 2;
      }
      rpc(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      ).then(res => {
        this.list = this.list.concat(res.productlistList);
        this.hasMore = res.productlistList.length;
        if (this.params.idlessthan !== 0) {
          window.scroll(0, scrollY);
        }
        this.loadmore = false;
      });
    },

    // 全选状态
    handleSelectionChange(i) {
      this.selectTable = i;
    },

    // 编辑商品
    onEdit(id) {
      this.$router.push({ name: 'products-edit', query: { id, type: 'edit' } });
    },

    // 上架
    onOnline(row) {
      row = JSON.parse(JSON.stringify(row));
      row.online = 1;
      rpc(
        'StoreProductService.UpdateProduct',
        M('ProductWithTokenRequest', {
          token: M('Token', { token: this.token }),
          product: M('Product', {
            ...row,
            optionsList: row.optionsList.map(v => M('Option', v)),
            productnoticelistList: row.productnoticelistList.map(v => M('ProductNotice', v)),
            producttimeslotlistList: row.producttimeslotlistList.map(item =>
              M('ProductTimeSlot', {
                weeklistList: item.weeklistList,
                producttimeslotpricelistList: item.producttimeslotpricelistList.map(item1 => M('ProductTimeSlotPrice', item1))
              })
            )
          })
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        this.$message({
          message: '商品上架成功',
          type: 'success'
        });
      });
    },

    // 下架商品
    onOffline(row) {
      row = JSON.parse(JSON.stringify(row));
      row.online = 0;
      rpc(
        'StoreProductService.UpdateProduct',
        M('ProductWithTokenRequest', {
          token: M('Token', { token: this.token }),
          product: M('Product', {
            ...row,
            optionsList: row.optionsList.map(v => M('Option', v)),
            productnoticelistList: row.productnoticelistList.map(v => M('ProductNotice', v)),
            producttimeslotlistList: row.producttimeslotlistList.map(item =>
              M('ProductTimeSlot', {
                weeklistList: item.weeklistList,
                producttimeslotpricelistList: item.producttimeslotpricelistList.map(item1 => M('ProductTimeSlotPrice', item1))
              })
            )
          })
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        this.$message({
          message: '商品下架成功',
          type: 'success'
        });
      });
    },

    // 批量下架
    onBatchOffline() {
      const ps = this.selectTable.map(row => {
        row = JSON.parse(JSON.stringify(row));
        row.online = 0;
        return rpc(
          'StoreProductService.UpdateProduct',
          M('ProductWithTokenRequest', {
            token: M('Token', { token: this.token }),
            product: M('Product', {
              ...row,
              optionsList: row.optionsList.map(v => M('Option', v)),
              productnoticelistList: row.productnoticelistList.map(v => M('ProductNotice', v)),
              producttimeslotlistList: row.producttimeslotlistList.map(item =>
                M('ProductTimeSlot', {
                  weeklistList: item.weeklistList,
                  producttimeslotpricelistList: item.producttimeslotpricelistList.map(item1 => M('ProductTimeSlotPrice', item1))
                })
              )
            })
          })
        );
      });
      Promise.all(ps).then(reslist => {
        reslist.forEach(res => {
          this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        });
        this.$message({
          message: '商品下架成功',
          type: 'success'
        });
      });
    },

    // 批量上架
    onBatchOnline() {
      const ps = this.selectTable.map(row => {
        row = JSON.parse(JSON.stringify(row));
        row.online = 1;
        return rpc(
          'StoreProductService.UpdateProduct',
          M('ProductWithTokenRequest', {
            token: M('Token', { token: this.token }),
            product: M('Product', {
              ...row,
              optionsList: row.optionsList.map(v => M('Option', v)),
              productnoticelistList: row.productnoticelistList.map(v => M('ProductNotice', v)),
              producttimeslotlistList: row.producttimeslotlistList.map(item =>
                M('ProductTimeSlot', {
                  weeklistList: item.weeklistList,
                  producttimeslotpricelistList: item.producttimeslotpricelistList.map(item1 => M('ProductTimeSlotPrice', item1))
                })
              )
            })
          })
        );
      });
      Promise.all(ps).then(reslist => {
        reslist.forEach(res => {
          this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        });
        this.$message({
          message: '商品上架成功',
          type: 'success'
        });
      });
    },

    // 批量设置分类
    onBatchCategory(id) {
      const ps = this.selectTable.map(row => {
        row = JSON.parse(JSON.stringify(row));
        row.categoryidlistList = [id];
        // 这一行兼容代码
        row.categoryid = id;
        return rpc(
          'StoreProductService.UpdateProduct',
          M('ProductWithTokenRequest', {
            token: M('Token', { token: this.token }),
            product: M('Product', {
              ...row,
              optionsList: row.optionsList.map(v => M('Option', v)),
              productnoticelistList: row.productnoticelistList.map(v => M('ProductNotice', v)),
              producttimeslotlistList: row.producttimeslotlistList.map(item =>
                M('ProductTimeSlot', {
                  weeklistList: item.weeklistList,
                  producttimeslotpricelistList: item.producttimeslotpricelistList.map(item1 => M('ProductTimeSlotPrice', item1))
                })
              )
            })
          })
        );
      });
      Promise.all(ps).then(reslist => {
        reslist.forEach(res => {
          this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        });
        this.$message({
          message: '修改分类成功',
          type: 'success'
        });
      });
    },

    minPrice(product) {
      var i = 0;
      if (product.withoption === 0) {
        i = product.price;
        if (product.discountprice !== 0) {
          i = product.discountprice;
        }
        if (product.vipprice !== 0) {
          i = product.vipprice;
        }
        if (product.supportgroup === 1) {
          i = product.groupprice;
        }
        return i;
      }
      for (var v of product.optionsList) {
        if (i === 0) {
          i = v.price;
        }
        if (v.price < i) {
          i = v.price;
        }
        if (v.discountprice !== 0 && v.discountprice < i) {
          i = v.discountprice;
        }
        if (v.vipprice !== 0 && v.vipprice < i) {
          i = v.vipprice;
        }
        if (product.supportgroup === 1 && v.groupprice < i) {
          i = v.groupprice;
        }
      }
      return i;
    },

    minQuantity(product) {
      if (product.withquantity === 2) {
        return null;
      }
      if (product.withoption === 0) {
        return product.quantity;
      }
      var i = 0;
      for (var v of product.optionsList) {
        if (i === 0) {
          i = v.quantity;
        }
        if (v.quantity < i) {
          i = v.quantity;
        }
      }
      return i;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-icon-star-on {
  margin-bottom: 0;
  display: none;
}
.el-icon-star-on.show {
  display: block;
}
.el-table__row:hover .el-icon-star-on {
  cursor: pointer;
  display: block;
}

.container:first-child {
  margin: 0;
}
.order-info {
  display: flex;
  flex-direction: row;
}
.order-info_img {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}
.order-info_base {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 180px;
}
.table-bottom {
  margin-top: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mutil-action {
  position: absolute;
  left: 0;
}
</style>
